import { Input } from 'antd'
import { useEffect, useState } from 'react'
import './IntegerNumberInput.scss'

export const IntegerNumberInput = ({ value, onChange, type }) => {
    const [inputValue, setInputValue] = useState('')

    const handleChange = e => {
        if (type === 'Compensation') {
            return setInputValue(e.target.value)
        }
        let result = e.target.value.replace(/[^\d]/g, '')
        let result2 = result.split('.')
        let result3
        if (result2.length >= 2) {
            result3 = (result2[0] ?? '') + '.' + (result2[1] ?? '')
        } else {
            result3 = result2[0] ?? ''
        }
        return setInputValue(result3)
    }

    useEffect(() => {
        setInputValue(value)
    }, [])

    useEffect(() => {
        onChange(inputValue)
    }, [inputValue])
    return (
        <Input
            className='IntegerNumberInput keepRight'
            placeholder=''
            value={inputValue}
            onChange={handleChange}
            allowClear={false}
        />
    )
}
